import { INITIAL_DATE } from "../../utils/constants";
import { formatDateFromAPI } from "../../utils/formatDate";
import { SAVE_SUPPLEMENTARY_DIPLOMA_INFO } from "../constant";

export const supplementaryInitialState = (data) => ({
	nameRegNoConfirmation: {},
	studentTypeId: data?.basicInformation?.studentTypeId,
	studentType: data?.basicInformation?.studentType,
	applicationTypeId: data?.basicInformation?.applicationTypeId ?? null,
	passport: {
		passport: data?.basicInformation?.passport
	},
	applicationNumber: data?.basicInformation?.applicationNumber,
	programmeInfo: {
		regNo: data?.regNumber,
		utmeScore: data?.programme?.utmeScore,
		faculty: {
			label: data?.programme?.faculty,
			value: data?.programme?.facultyId
		},
		facultyShoppingInto: {
			label: data?.programme?.facultyShoppingInto,
			value: data?.programme?.facultyShoppingIntoId
		},
		department: {
			label: data?.programme?.department,
			value: data?.programme?.departmentId
		},
		departmentOption: {
			label: data?.programme?.departmentOption,
			value: data?.programme?.departmentOptionId
		},
		courseShoppingInto: {
			label: data?.programme?.courseShoppingInto,
			value: data?.programme?.courseShoppingIntoId
		},
		supplementaryApplicationDate:
			data?.programme?.supplementaryApplicationDate,
		rrr: data?.basicInformation?.rrr
	},
	personalInfo: {
		firstname: data?.basicInformation?.firstname,
		middlename: data?.basicInformation?.middlename,
		surname: data?.basicInformation?.lastname,
		...(data?.basicInformation?.dateOfBirth && {
			dateOfBirth:
				data?.basicInformation?.dateOfBirth === INITIAL_DATE
					? ""
					: formatDateFromAPI(data?.basicInformation?.dateOfBirth)
		}),
		...(data?.basicInformation?.gender && {
			sex: {
				label: data?.basicInformation?.gender,
				value: data?.basicInformation?.genderId
			}
		}),
		...(data?.basicInformation?.maritalStatus && {
			maritalStatus: {
				label: data?.basicInformation?.maritalStatus,
				value: data?.basicInformation?.maritalStatusId
			}
		}),
		mobileNo: data?.basicInformation?.mobileNumber,
		email: data?.basicInformation?.email,
		contactAddress: data?.basicInformation?.contactAddress,

		...(data?.basicInformation?.country && {
			country: {
				label: data?.basicInformation?.country,
				value: data?.basicInformation?.countryId
			}
		}),
		...(data?.basicInformation?.state && {
			state: {
				label: data?.basicInformation?.state,
				value: data?.basicInformation?.stateId
			}
		}),
		...(data?.basicInformation?.lga && {
			lga: {
				label: data?.basicInformation?.lga,
				value: data?.basicInformation?.lgaId
			}
		}),
		rrr: data?.basicInformation?.rrr,
		nin: data?.basicInformation?.nin,
		abssin: data?.basicInformation?.abssin
	}
});

export const supplementaryDiplomaReducer = (state = {}, action) => {
	switch (action.type) {
		case SAVE_SUPPLEMENTARY_DIPLOMA_INFO:
			return action.payload;
		default:
			return state;
	}
};
